const REGISTER = 'grugn-guitars-modern/carousel/REGISTER';
const UNREGISTER = 'grugn-guitars-modern/carousel/UNREGISTER';

const RIGHT_ARROW = 'grugn-guitars-modern/carousel/RIGHT_ARROW';
const LEFT_ARROW = 'grugn-guitars-modern/carousel/LEFT_ARROW';

export interface ICarouselAction {
    type: string;
    name: string;
    count?: number;
}

export interface ICarouselUnit {
    name: string;
    count: number;
    active_slide: number;
}

export interface ICarouselState {
    carousels: ICarouselUnit[];
}

const initialState: ICarouselState = {
    carousels: []
};

export default function (state: ICarouselState = initialState, action: ICarouselAction) {
    switch (action.type) {
        case REGISTER:
            if (state.carousels.find(v => v.name === action.name)) {
                return state;
            }
            return({ ...state, carousels: [...state.carousels, { name: action.name, count: action.count, active_slide: 0 }] });
        case UNREGISTER:
            return({ ...state, carousels: state.carousels.filter(val => val.name !== action.name) });
        case RIGHT_ARROW:
            return { ...state, carousels: state.carousels.map(val => val.name === action.name ? { ...val, active_slide: val.active_slide + 1 === val.count ? 0 : val.active_slide + 1 } : val) };
        case LEFT_ARROW:
            return { ...state, carousels: state.carousels.map(val => val.name === action.name ? { ...val, active_slide: val.active_slide - 1 === -1 ? val.count - 1 : val.active_slide - 1 } : val) };
        default:
            return state;
    }
}

export const rightArrow = (name: string): ICarouselAction => ({ type: RIGHT_ARROW, name });
export const leftArrow = (name: string): ICarouselAction => ({ type: LEFT_ARROW, name });
export const register = (name: string, count: number): ICarouselAction => ({ type: REGISTER, name, count });
export const unregister = (name: string): ICarouselAction => ({ type: UNREGISTER, name });



// WEBPACK FOOTER //
// ./src/redux/modules/carousel.ts